import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMore = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.03366 8C5.94728 8.02805 6.78832 8.67133 6.96316 9.59089C7.12107 10.4224 6.7639 11.2765 6.03454 11.7167C5.30517 12.1607 4.36527 12.0704 3.71485 11.5324C3.09076 11.0169 2.8351 10.1139 3.10955 9.35008C3.39554 8.55464 4.12916 8.02725 4.96969 8.00009",
			fill: "#4298D7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0337 8C10.9473 8.02805 11.7883 8.67133 11.9632 9.59089C12.1211 10.4224 11.7639 11.2765 11.0345 11.7167C10.3052 12.1607 9.36527 12.0704 8.71485 11.5324C8.09076 11.0169 7.8351 10.1139 8.10955 9.35008C8.39554 8.55464 9.12916 8.02725 9.96969 8.00009",
			fill: "#4298D7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.0337 8C15.9473 8.02805 16.7883 8.67133 16.9632 9.59089C17.1211 10.4224 16.7639 11.2765 16.0345 11.7167C15.3052 12.1607 14.3653 12.0704 13.7149 11.5324C13.0908 11.0169 12.8351 10.1139 13.1096 9.35008C13.3955 8.55464 14.1292 8.02725 14.9697 8.00009",
			fill: "#4298D7"
		})
	]
});
export default SvgMore;
